import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Principal from '../pages/Principal';
import Paypal from '../pages/Paypal';
import Unica from '../pages/DoacaoUnica';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Principal} />
    <Route path="/internacional" exact component={Paypal} />
    <Route path="/unica" exact component={Unica} />

  </Switch>
);

export default Routes;
